export const isAllowedToConfigure = (constraintsValidationResult) => (constraintsValidationResult === false);

export const isMissingUserPermission = (constraintsValidationResult) => (constraintsValidationResult === 'MissingUserPermission');

export const isOrgConstraintSet = (constraintsValidationResult) => (constraintsValidationResult === 'OrgPolicyConstraintSet');

export const checkForClassName = (allowedToConfigure, disabled, clickableClass) => ((!allowedToConfigure || disabled) ? 'form-label' : clickableClass);
